// this is an utility to download an .ics file for calendar events
// src/utils/calendar.js

export function downloadICS({
  title,
  description = '',
  start,                 // Date object in LOCAL time
  durationMinutes = 15,  // your desired length
  alarms = ['-P1D', '-PT1H'] // 1 day & 1 hour before
}) {
  const CRLF = '\r\n';
  const esc = (s) => String(s).replace(/([\\;,])/g, '\\$1').replace(/\n/g, '\\n');

  // FLOATING (local) time: YYYYMMDDTHHMMSS (no Z, no TZID)
  const toICSLocal = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds()).padStart(2, '0');
    return `${y}${m}${day}T${hh}${mm}${ss}`;
  };

  const nowStampUTC = toUTCStamp(new Date());
  const dtstartLocal = toICSLocal(start);
  const dtendLocal = toICSLocal(new Date(start.getTime() + durationMinutes * 60000));

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//NeuroGreen//Reminders//EN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${uid()}`,
    `DTSTAMP:${nowStampUTC}`,   // DTSTAMP in UTC is fine
    `DTSTART:${dtstartLocal}`,  // floating LOCAL time (no Z)
    `DTEND:${dtendLocal}`,      // floating LOCAL time (no Z)
    `SUMMARY:${esc(title)}`,
    `DESCRIPTION:${esc(description)}`,
    ...alarms.flatMap((trig) => [
      'BEGIN:VALARM',
      'ACTION:DISPLAY',
      `TRIGGER:${trig}`,
      `DESCRIPTION:${esc(title)}`,
      'END:VALARM',
    ]),
    'END:VEVENT',
    'END:VCALENDAR',
  ];

  const ics = lines.join(CRLF);
  const blob = new Blob([ics], { type: 'text/calendar' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'neurogreen-reminder.ics';
  a.click();
  URL.revokeObjectURL(url);

  // helpers
  function uid() {
    return (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`) + '@neurogreen';
  }
  function toUTCStamp(d) {
    return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
  }
}
